let Fortune = {
    loading: false,
    initialized: false,
    picked: false,
    ending: false,
    top: false,
    init: () => {
        Fortune.check();
    },
    check: () => {
        if (!Fortune.loading) {
            let container = document.getElementById("fortune_container");
            Fortune.loading = true;
            container.innerHTML = Fortune.renderLoadingGame();
            Api.get("/fortune/check", {}, (r) => {
                if (r.success) {
                    Fortune.initialized = r.hasGame;
                    if (Fortune.initialized) {
                        container.innerHTML = Fortune.render(
                            r.currentLevel,
                            false,
                            r.levels.current,
                            r.levels.max,
                            r.inventory
                        );
                    } else {
                        container.innerHTML = Fortune.renderNewGameHTML();
                    }
                }
            });
            Fortune.loading = false;
        }
    },
    renderLoadingGame: () => {
        return `
         <div class="game__container">
            <div class="game__start">Cargando recursos...</div>
        </div>
      `;
    },
    renderEndGame: () => {
        return `
        <div class="game__container">
            <div class="game__start">¡Has perdido! :(</div>
            <button class="button purple big" onclick="Fortune.newGame();">Nueva partida</button>
        </div>
      `;
    },
    pickCard: (id) => {
        let container = document.getElementById("fortune_container");

        if (!Fortune.picked) {
            Fortune.picked = true;
            Api.post("/fortune/pick", { card: id }, (r) => {
                if (r.success) {
                    //  Alert.push([{type: 'success', text: '¡Bien! Tu carta ha sido seleccionada con éxito.', icon: 'circle-check'}]);

                    let counter = 0;
                    let cards = document.querySelectorAll(".game__card");

                    cards.forEach((el) => {
                        el.innerHTML = Fortune.translatePrizeCard(
                            r.data,
                            counter
                        );
                        counter++;
                        el.classList.add("disabled", "animated", "flipInY");
                    });

                    let selected = document.getElementById(`game_card_${id}`);
                    selected.classList.remove("flipInY");
                    selected.classList.add(
                        `selected-${r.end ? "error" : "good"}`,
                        "shake"
                    );

                    if (r.end) {
                        setTimeout(() => {
                            container.innerHTML = Fortune.renderEndGame();
                        }, 5000);
                    } else if (r.maxLevel) {
                        setTimeout(() => {
                            container.innerHTML = Fortune.renderWinGame(
                                r.inventory
                            );
                        }, 5000);
                    } else {
                        setTimeout(() => {
                            container.innerHTML = Fortune.render(
                                r.current_level,
                                false,
                                r.levels.current,
                                r.levels.max,
                                r.inventory
                            );
                            Fortune.picked = false;
                        }, 5000);
                    }
                } else {
                    if (r.error.identifier === "game_ended_or_lost") {
                        Alert.push([
                            {
                                type: "danger",
                                text: "¡Oops! Has perdido la partida o te has retirado.",
                                icon: "circle-alert",
                            },
                        ]);
                        container.innerHTML = Fortune.renderNewGameHTML();
                    } else if (r.error.identifier === "expired_game") {
                        Alert.push([
                            {
                                type: "danger",
                                text: "¡Oops! El tiempo permitido para jugar esta partida ha expirado.",
                                icon: "circle-alert",
                            },
                        ]);
                        container.innerHTML = Fortune.renderNewGameHTML();
                    } else if (r.error.identifier === "card_invalid") {
                        Alert.push([
                            {
                                type: "danger",
                                text: "¡Oops! La carta que has elegido es inválida. Prueba de nuevo.",
                                icon: "circle-alert",
                            },
                        ]);
                    } else if (r.error.identifier === "internal_error") {
                        Alert.push([
                            {
                                type: "danger",
                                text: "¡Oops! Algo ha salido mal.",
                                icon: "circle-alert",
                            },
                        ]);
                    }
                }
            });
        }
    },

    renderWinGame: (prizes) => {
        return `
            <div class="game__container full">
                <div class="game__start">WIN or BAN: ¡Has ganado!</div>
                ${Fortune.renderWonPrizes(prizes)}
            </div>
        `;
    },

    renderLevels: (
        current,
        refreshLevels = false,
        initialValue = 1,
        maxValue = 10
    ) => {
        let levels = "";
        console.log(initialValue, maxValue);

        let max = maxValue;
        let initial = initialValue;

        for (let i = initial; i < initial + max; i++) {
            let isFree = i % 5 === 0;
            let passed = i < current;

            levels += `
                 <div id="level_${i}" class="level ${passed && "pass"}  ${
                i === current && "current"
            } ${isFree && "free"}">${i}</div>
            `;
        }

        return `
            <div class="game__progress">
                ${levels}
            </div>
        `;
    },
    renderButtonOptions: () => {
        return `
        <div class="game__options">
            <button class="button red big" onclick="Fortune.endGame();">Retirarme</button>
        </div>
      `;
    },
    endGame: () => {
        if (!Fortune.ending && !Fortune.picked) {
            Fortune.ending = true;
            Api.post("/fortune/end-game", {}, (r) => {
                if (r.success) {
                    Alert.push([
                        {
                            type: "success",
                            text: "¡Bien! El juego se ha finalizado con éxito.",
                            icon: "circle-check",
                        },
                    ]);
                    Fortune.check();
                } else {
                    if (r.error.identifier === "game_not_found") {
                        Alert.push([
                            {
                                type: "danger",
                                text: "¡Oops! El juego que intentas terminar no existe.",
                                icon: "circle-alert",
                            },
                        ]);
                    } else if (r.error.identifier === "internal_error") {
                        Alert.push([
                            {
                                type: "danger",
                                text: "¡Oops! Algo ha salido mal.",
                                icon: "circle-alert",
                            },
                        ]);
                    }
                }
            });
            Fortune.ending = false;
        }
    },

    translatePrize: ({ prize, type, extradata }) => {
        let prizeHTML = "";

        if (type === "tiums") {
            prizeHTML = `
                <div style="position:absolute;">
                    <span class="glyphicons glyphicons-coins"></span>
                </div>
                <span class="indicator">x${extradata}</span>
            `;
        } else if (type === "afro_hours") {
            prizeHTML = `
                 <div style="position:absolute;">
                    <span class="glyphicons glyphicons-tree-deciduous"></span>
                </div>
                <span class="indicator">x${extradata}</span>
            `;
        } else if (type === "bronze_coin") {
            prizeHTML = `
                <div style="position:absolute;">
                   <img src="https://cdn.habtium.com/win-or-ban/money_big_coin.png" alt="habbo credit" style="width:15px" />
                </div>
                <span class="indicator">x${extradata}</span>
            `;
        } else if (type === "icon_1_rare") {
            prizeHTML = `
                 <div style="position:absolute;">
                    <span class="glyphicons glyphicons-fabric"></span>
                </div>
                <span class="indicator">x${extradata}</span>
            `;
        } else if (type === "ach_1_rare") {
            prizeHTML = `
                 <div style="position:absolute;">
                    <span class="glyphicons glyphicons-certificate"></span>
                </div>
                <span class="indicator">x${extradata}</span>
            `;
        }

        return prizeHTML;
    },

    translatePrizeCard: (array, counter) => {
        let prizeHTML = `
        `;

        let t = array[counter];

        if (t.type === "tiums") {
            prizeHTML = `
               <div style="color:white;font-size: 48px;">
                    <span class="glyphicons glyphicons-coins"></span>
                </div>
                <div class="prize-information">Tiums: ${t.value}</div>
            `;
        } else if (t.type === "afro_hours") {
            prizeHTML = `
                 <div style="color:white;font-size: 48px;">
                    <span class="glyphicons glyphicons-tree-deciduous"></span>
                </div>
                <div class="prize-information">Club Afro: ${t.value} (hora/s)</div>
            `;
        } else if (t.type === "ban_lost_game") {
            prizeHTML = `
                <img src="https://cdn.habtium.com/win-or-ban/banned.png" alt="Perdiste"/>
                <div class="prize-information">PERDISTE</div>
            `;
            /**/
        } else if (t.type === "bronze_coin") {
            prizeHTML = `
                <img src="https://cdn.habtium.com/win-or-ban/money_big_coin.png" alt="habbo credit" />
                <div class="prize-information">1 Habbo crédito</div>
            `;
        }

        return prizeHTML;
    },

    renderWonPrizes: (prizes) => {
        let prizesHTML = "";
        let i = 0;
        prizes.map((prize) => {
            prizesHTML += `
                <div class="inventory-item ${
                    i === prizes.length - 1 ? "animated bounceInDown" : ""
                }">
                    ${Fortune.translatePrize(prize)}
                </div>
            `;
            i++;
        });

        return `
            <div class="game__prizes">
                <div class="title">Tus premios</div>
                <div class="warning">
                    Estos son los premios que tienes acumulados hasta este momento, recuerda que si pierdes, no obtendrás
                    ninguna de estas recompensas, para ello, deberás ganar todos los niveles disponibles o retirarte.
                </div>
                <div class="inventory">
                   ${prizesHTML}
                </div>
            </div>
        `;
    },
    render: (level, refresh, ini, max, prizes = []) => {
        return `
        <div class="game__container full">
            ${Fortune.renderLevels(level, refresh, ini, max)}
            <div class="game__board">
                <div id="game_card_1" class="game__card" onclick="Fortune.pickCard(1);">?</div>
                <div id="game_card_2" class="game__card" onclick="Fortune.pickCard(2);">?</div>
                <div id="game_card_3" class="game__card" onclick="Fortune.pickCard(3);">?</div>
                <div id="game_card_4" class="game__card" onclick="Fortune.pickCard(4);">?</div>
            </div>
            ${level > 1 ? Fortune.renderButtonOptions() : ""}
            ${prizes.length > 0 ? Fortune.renderWonPrizes(prizes) : ""}
        </div>
      `;
    },
    newGame: () => {
        Fortune.picked = false;
        let container = document.getElementById("fortune_container");
        let coins = document.getElementById("coins_balance");
        Api.post("/fortune/new", {}, (r) => {
            if (r.success) {
                Alert.push([
                    {
                        type: "success",
                        text: "¡Bien! Una partida se ha iniciado.",
                        icon: "circle-check",
                    },
                ]);
                container.innerHTML = Fortune.render(1);
                coins.innerText = r.balance;
            } else {
                if (r.error.identifier === "coins_insufficient") {
                    Alert.push([
                        {
                            type: "danger",
                            text: "¡Oops! No tienes los suficientes tiums para iniciar una partida.",
                            icon: "circle-alert",
                        },
                    ]);
                } else if (r.error.identifier === "no_game_initialized") {
                    Fortune.check();
                }
            }
        });
    },
    renderNewGameHTML: () => {
        return `
            <div class="game__container full">
                <div class="game__start">WIN or BAN</div>
                <button class="button purple big" onclick="Fortune.newGame();">Nueva partida</button>
            </div>
        `;
    },
    loadPrizes: () => {
        let container = document.getElementById("prizes-container");
        let prizes = "";
        prizes.innerHTML = Fortune.renderLoadingGame();
        Api.get("/fortune/prizes", {}, (r) => {
            if (r.success) {
                prizes = "";
                if (r.data.length > 0) {
                    r.data.map((e) => {
                        prizes += `
                        <tr>
                            <td>${
                                e.extradata.title ? e.extradata.title : e.code
                            }</td>
                            <td>${
                                e.extradata.description
                                    ? e.extradata.description
                                    : "no description"
                            }</td>
                            <td>${e.unlimited ? "∞" : e.available_quantity}</td>
                        </tr>
                      `;
                    });
                }

                container.innerHTML = `
                <table>
                    <tbody>
                        <tr>
                            <th>Premio</th>
                            <th>Descripción</th>
                            <th>Cantidad</th>
                        </tr>
                    </tbody>
                    <tbody>
                        ${prizes}
                    </tbody>
                </table>
              `;
            }
        });
    },
    renderTopFive: (data) => {
        let dataHTML = "";

        data.map((user) => {
            dataHTML += `
            <div class="account-box">
                <div class="avatar" style="background-image:url(${user.user.avatar});">
                    <a href="/${user.user.username}"></a>
                </div>
                <div class="body">
                    <span>
                        <h1><a href="/${user.user.username}">${user.user.username}</a></h1> <i>${user.user.nick}</i>
                        <h2>${user.score} puntos</h2>
                    </span>
                </div>
            </div>
           `;
        });

        return dataHTML;
    },
    getTopFive: () => {
        if (!Fortune.top) {
            Fortune.top = true;
            let container = document.getElementById("top_five");
            Api.get("/fortune/top", {}, (r) => {
                if (r.success) {
                    container.innerHTML = Fortune.renderTopFive(r.data);
                }
            });

            Fortune.top = false;
        }
    },
};
